var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53796 6.49989C1.53796 3.6377 3.86612 1.31006 6.7278 1.31006C9.58947 1.31006 11.9176 3.6377 11.9176 6.49989C11.9176 9.36156 9.58947 11.6897 6.7278 11.6897C5.10493 11.6897 3.60507 10.9512 2.61382 9.66465C2.48667 9.49909 2.51729 9.26192 2.68284 9.13529C2.84736 9.00762 3.08401 9.03927 3.21168 9.20379C4.05918 10.304 5.34055 10.9351 6.7278 10.9351C9.17324 10.9351 11.163 8.94586 11.163 6.49989C11.163 4.05444 9.17324 2.06466 6.7278 2.06466C4.28235 2.06466 2.29257 4.05444 2.29257 6.49989C2.29257 6.7272 2.30969 6.95296 2.34343 7.17405C2.37456 7.37957 2.2334 7.57211 2.02736 7.60377C1.82029 7.63802 1.62879 7.49426 1.59765 7.28823C1.5582 7.02977 1.53796 6.76457 1.53796 6.49989ZM6.72768 4.14064C6.51282 4.14064 6.33844 4.31502 6.33844 4.52988V6.82379C6.33844 7.03864 6.51282 7.21302 6.72768 7.21302C6.94253 7.21302 7.11691 7.03864 7.11691 6.82379V4.52988C7.11691 4.31502 6.94253 4.14064 6.72768 4.14064ZM6.7328 8.08066H6.72761C6.51276 8.08066 6.34097 8.25504 6.34097 8.4699C6.34097 8.68475 6.51795 8.85913 6.7328 8.85913C6.94766 8.85913 7.12204 8.68475 7.12204 8.4699C7.12204 8.25504 6.94766 8.08066 6.7328 8.08066Z",
    fill: "#92929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/InfoCircle.97d96f4678994d2a32960f1f75b6906e.svg";
export { ForwardRef as ReactComponent };